import { useNavigate } from 'react-router-dom'
import { useProgressStore } from '../../Stores/progressStore'
import { ROUTES } from '../../constants/routes'

const FIRST_PROGRESS = 1

export const useNavigateRouteResume = () => {
  const navigate = useNavigate()
  const { setCurrentStep, setAllRoutesNavigated } = useProgressStore()

  const handleResumeNavigate = (currentRoute: string) => {
    const routesValues = Object.values(ROUTES)
    const indexOfRouter = routesValues.indexOf(currentRoute)

    setAllRoutesNavigated(routesValues.slice(0, indexOfRouter))
    setCurrentStep(indexOfRouter + 1)

    navigate(currentRoute)
    const nextButton: HTMLElement = document.querySelector(
      '.progress-petis-container .flickity-button.flickity-prev-next-button.next',
    ) as HTMLElement

    if (nextButton) {
      for (let index = FIRST_PROGRESS; index < indexOfRouter; index++) {
        nextButton.click()
      }
    }
  }

  return {
    handleResumeNavigate,
  }
}
